module.exports = __webpack_public_path__ + "img/cxample_17.4ed6db2f.png";